exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".heading-title1{font-family:Ek Mukta,sans-serif;font-weight:600;font-style:normal;font-size:22px;color:#000;text-align:center}.stepOver{position:absolute;border:1px solid #cf004a;padding:5px;border-radius:1.5em;margin-left:-50px;margin-top:5px}span.step{background:#cf004a;border-radius:.8em;-moz-border-radius:.8em;-webkit-border-radius:.8em;color:#fff;display:inline-block;font-weight:700;line-height:1.6em;text-align:center;width:1.6em}.ullist{list-style:none}.ullist li:before{position:absolute;content:\"\\2713\";margin-left:-20px;color:green}.w50{width:50%}@media only screen and (max-width:768px){.w50{width:62%}}@media only screen and (min-width:768px){.container{width:90%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e1fcd6a","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/auth/account-info.vue
// module id = 848
// module chunks = 0